import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/components/Header";
import { Sidebar } from "@/components/layout/components/Sidebar";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { SubscriptionLockOverlay } from "@/components/layout/components/SubscriptionLockOverlay";
import { ActiveHotelLockOverlay } from "@/components/layout/components/ActiveHotelLockOverlay";
import { FrontdeskBlockGuard } from "@/components/auth/FrontdeskBlockGuard";

export const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { userProfile, isLoading } = useAuthenticatedUser();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar open={sidebarOpen} />

      <div className={cn("flex min-h-0 flex-1 flex-col overflow-hidden")}>
        <Header
          onOpenSidebar={toggleSidebar}
          sidebarOpen={sidebarOpen}
          onToggle={toggleSidebar}
        />
        <main className="font-geist min-h-0 flex-1 overflow-x-clip overflow-y-auto">
          <FrontdeskBlockGuard>
            <Outlet />
          </FrontdeskBlockGuard>
        </main>
      </div>
      <SubscriptionLockOverlay
        isLoading={isLoading}
        userProfile={userProfile}
      />
      <ActiveHotelLockOverlay isLoading={isLoading} userProfile={userProfile} />
    </div>
  );
};
